// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"home_mainBox__9gx4i"};